import CurrentStatementUsa from './CurrentStatementUsa';
import { withI18n } from 'react-i18next';
export default withI18n()(CurrentStatementUsa);
